import { type Hash } from 'history';
import { matchPath } from 'react-router';

import parseHashSearchParam from '../parseHashSearchParam';

const verifySignupMatcher = (hash: Hash) => {
  const path = hash.substring(1);
  const [pathname, search] = path.split('?');
  const match = matchPath('/verify-signup', pathname);
  if (!match) {
    return null;
  }
  return {
    token: parseHashSearchParam(search, 'token'),
    email: parseHashSearchParam(search, 'email'),
  };
};

export default verifySignupMatcher;
